import { http } from './Connect';
import type { MfaResponse } from './schema';
import { AuthTokenData } from './schema';
import SecureLS from 'secure-ls';
import jwt_decode from 'jwt-decode';

const ls = new SecureLS();
const token = ls.get('tokenKey');

export const getMfa = async (): Promise<MfaResponse> => {
  let role: string;
  try {
    const tokenData: AuthTokenData = jwt_decode(token);
    role = tokenData.role;
  } catch (error) {
    console.error('Token is not valid');
    throw new Error(`Can't get MFA info`);
  }

  if (typeof role !== 'string') {
    console.error('Role is not valid');
    throw new Error(`Can't get MFA info`);
  }

  const result: MfaResponse = {
    isMfaEnabled: false,
    mfaValue: null,
    mfaQrCode: null
  };

  if (role === 'ROLE_ACCOUNT') {
    const { data } = await http.get<{
      mfaEnabled: boolean;
    }>('/api/v1/operator-onboarding/account', {
      cacheTime: 0
    });

    result.isMfaEnabled = !!data?.mfaEnabled;
  } else {
    const { data } = await http.get<{
      mfaEnabled: boolean;
    }>('/api/v2/admin/info', {
      cacheTime: 0
    });

    result.isMfaEnabled = !!data?.mfaEnabled;
  }

  if (!result.isMfaEnabled) {
    const { data } = await http.get<{
      value: string;
      qrCode: string;
    }>('/api/v2/security/mfa/qr', {
      cacheTime: 0
    });

    result.mfaValue =
      typeof data?.value === 'string' && !!data.value ? data?.value : null;
    result.mfaQrCode =
      typeof data?.qrCode === 'string' && !!data.qrCode ? data?.qrCode : null;
  }

  return result;
};

export const enableMfa = async (mfaCode: string): Promise<void> => {
  await http.patch('/api/v2/security/mfa/enable', mfaCode);
};

export const disableMfa = async (mfaCode: string): Promise<void> => {
  await http.patch('/api/v2/security/mfa/disable', mfaCode);
};
